import { app } from "@/app.context";
import {
  studyProgramMatchesAreasOfInterest,
  studyProgramMatchesDepartments,
  studyProgramMatchesLanguages,
  studyProgramMatchesLevels,
  studyProgramMatchesLocations,
  studyProgramMatchesModes,
} from "@/views/components/filters/filter-functions";
import { createFilterObject } from "@/views/components/filters/FilterSection.types.";
import {
  PublicStudyProgramDto,
  PublicStudyProgramMetaDataLocalizationDto,
} from "lib/eduConfigurationServiceClient";

export default function createStudyProgramFilter(
  studyPrograms: PublicStudyProgramDto[],
  localizations: PublicStudyProgramMetaDataLocalizationDto,
) {
  const mode = createFilterObject(
    "mode",
    localizations.modeLocalization ?? app.texts.studyProgram.mode,
    studyProgramMatchesModes,
    studyPrograms,
    (studyProgram) => studyProgram.mode,
  );

  const level = createFilterObject(
    "level",
    localizations.levelLocalization ?? app.texts.studyProgram.level,
    studyProgramMatchesLevels,
    studyPrograms,
    (studyProgram) => studyProgram.level,
  );

  const areas = createFilterObject(
    "areaOfInterest",
    localizations.areaOfInterestLocalization ??
      app.texts.studyProgram.areaOfInterest,
    studyProgramMatchesAreasOfInterest,
    studyPrograms,
    (studyProgram) => studyProgram.areasOfInterest,
  );

  const language = createFilterObject(
    "language",
    app.texts.studyProgram.language,
    studyProgramMatchesLanguages,
    studyPrograms,
    (studyProgram) => studyProgram.language,
  );

  const locations = createFilterObject(
    "location",
    localizations.locationLocalization ?? app.texts.studyProgram.location,
    studyProgramMatchesLocations,
    studyPrograms,
    (studyProgram) => studyProgram.locations,
  );

  const department = createFilterObject(
    "department",
    localizations.departmentLocalization ?? app.texts.studyProgram.department,
    studyProgramMatchesDepartments,
    studyPrograms,
    (studyProgram) => studyProgram.department,
  );

  return [mode, level, areas, language, locations, department];
}
